<template>
  <b-card title="Kiosk PO List ">
    <b-modal v-model="modalConfirmation" :title="modalTitle">
      <!-- Alert before Delete PO-->
      <b-container>
        <b-row>
          <b-col cols="12" >
            <div class="d-flex">
              Are you sure want to {{ messageModal }} this {{selectPO.PONumber}} ?
            </div>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-center align-items-center">
          <b-button variant="danger" class="ml-1" @click="confirmEdit">Confirm</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal v-model="modalDelete" title="Delete Kiosk PO">
    <!-- Alert before Delete PO-->
      <b-container>
        <b-row>
          <b-col cols="12" >
            <div class="d-flex">
              Are you sure want to delete this {{selectPO.PONumber}} ?
            </div>
          </b-col>
        </b-row>
      </b-container>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-center align-items-center">
          <b-button variant="danger" class="ml-1" @click="confirmDelete">Confirm</b-button>
        </div>
      </template>
    </b-modal>
    <!-- End of Modal Needed on this page-->
    <b-col cols="12">
      <b-row>
        <b-col cols="4">
          <b-button
            v-if="checkPermissionAdd"
            variant="success"
            :to="{name:'kiosk-po-add'}"
          >
            Add Kiosk PO
          </b-button>
        </b-col>
        <b-col cols="4">
        </b-col>
        <b-col cols="4">
          <strong>Search By PO Number</strong>
          <b-form-input
            @input="(value) => doFiltering(value)"
            v-model="search"
            type="search"
            placeholder="Type to Search"
          />
        </b-col>
        <br>
        <b-col cols="4">
          <strong>Filter by Status:</strong>
          <b-form-select
            @input="(value) => statusFiltering(value)"
            v-model="sapStatus"
            :options="statusOptions"
          >
          </b-form-select>
        </b-col>
        
        <b-col style="margin: 15px 0 0 0" cols="12">
          <b-table
            class="custom-row-height"
            :busy.sync="tableLoading"
            show-empty
            :items="mappedPurchase"
            :fields="fields"
            thead-class="compact-header"
            tbody-class="compact-body"
          >
            <template #cell(createdAt)="row">
              {{dates(row.item.createdAt)}}
            </template>
            <template #cell(status)="row">{{ statusParser(row.item) }}</template>
            <template #cell(actions)="row">
              <b-dropdown  id="dropdown-dropleft" variant="primary" size="sm" text="Menu" no-caret>
                <template #button-content>
                  <feather-icon size="1x" icon="MenuIcon" />
                </template>
                  <b-dropdown-item style="text-align:center">
                    <b-button size="sm" @click="detailPO(row)" variant="info" class="mr-1">
                      <feather-icon icon="EyeIcon"/>
                    </b-button>
                  </b-dropdown-item>
                  <!-- <b-dropdown-item style="text-align:center" v-if="(row.item.orderStatus === 'Editing') && permission.edit">
                    <b-button size="sm" @click="editDraft(row)" variant="outline-primary" class="mr-1">
                      <feather-icon icon="EditIcon"/>
                    </b-button>
                  </b-dropdown-item> -->
                  <!-- <b-dropdown-item style="text-align:center" v-if="row.item.orderStatus === '' && permission.delete"> 
                    <b-button size="sm" variant="danger"  @click="deleteDraft(row.item)" class="mr-1">
                      <feather-icon icon="Trash2Icon"/>
                    </b-button>
                  </b-dropdown-item> -->
                <!-- <b-dropdown-item style="text-align:center" v-if="row.item.orderStatus === 'Editing' && permission.edit"> 
                  <b-button size="sm" variant="danger"  @click="cancelOrder(row)" class="mr-1">
                    Cancel Order
                  </b-button>
                </b-dropdown-item> -->
              </b-dropdown>
            </template>
          </b-table>
          <!--<step-progress :length="3" :finished="3" :returned="true"></step-progress>-->
        </b-col>
        
        <b-col cols="12">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            @change="onPageChange"
            v-model="currentPage"
            style="float: right"
          />
        </b-col>
      </b-row>
      
    </b-col>
    
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {userAccess,dateFormat} from '@/utils/utils'
import lodash from 'lodash';
import axios from '@/axios';
import stepProgress from '@/components/StepProgress.vue'

export default {
  components: {
    stepProgress
  },
  data() {
    return {
      fields: [
        { key: 'rspOrderNumber', label: 'Order Number', filterable: true, sortable: true },
        { key: 'status', label: 'Status', filterable: true, sortable: true, },
        { key: 'createdAt', label:'Kiosk PO Created Date', filterable: true, sortable: true},
        { key: 'actions', label: 'Actions' },
      ],
      search: '',
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      tableLoading: true,
      modalDelete: false,
      selectPO:'',
      sapStatus: 'Created',
      modalConfirmation: false,
      modalTitle: "",
      modalConfirmation: false,
      messageModal : "",
      statusOptions: [
        { value: 'ALL', text: 'All' },
        { value: 'Created', text: 'Created' },
        { value: 'Awaiting Discount Approval', text: 'Awaiting Discount Approval' },
        { value: 'Checking', text: 'Checking' },
        { value: 'Editing', text: 'Editing' },
        { value: 'SO Creating', text: 'SO Creating' },
        { value: 'SO Created', text: 'SO Created' },
        { value: 'DO Created', text: 'DO Created' },
        { value: 'Canceled', text: 'Canceled' },
        { value: 'PO Fail', text: 'Pending' }
      ],
    }
  },
  mounted() {
    
    const toastMsg = sessionStorage.getItem("toastMessage");
    if (toastMsg) {
      this.$bvToast.toast(toastMsg, {
        title: "Success",
        variant: "success",
        solid: true,
      });
      sessionStorage.removeItem("toastMessage"); // agar tidak muncul lagi saat reload
    }
    this.$store.dispatch("dealer/getCurrentDealer"); 
    this.$store
      .dispatch('auth/fetchUser')
      .catch(err => console.log(err))
    
    this.getPurchase({ 
      page:this.currentPage, 
      entry:this.perPage,
      orderStatus: this.sapStatus, 
      allAccess: this.permission.all, 
      kioskFlag: true, 
      kioskFlag: true })
    .then((data) => this.processMetadata(data.metadata));
      
  },
  computed: {
    ...mapGetters({
      purchase: 'purchase/purchase',
    }),
    mappedPurchase(){
      return this.purchase.map(item => {
        return {
          ...item,
          rspOrderNumber: item.PONumber.includes('*') ? item.PONumber.substring(0, 13) : item.PONumber,
          customerPo: item.PONumber.includes('*') ? item.PONumber.substring(14) : ""
        }
      })
    },
    currentDealer() {
      var tempDealer = this.$store.getters["dealer/getCurrentDealers"]
      
      if(tempDealer === null || tempDealer === undefined){
        tempDealer = {
          status : "Not Allowed"
        }
      }else{
        tempDealer = {
          status : "Allowed"
        }
      }
      return tempDealer
    },
    user() {
      return this.$store.getters['auth/getActiveUser'];
    },
    permission() {
      //console.log(userAccess("Order", "order_menu"));
      
      return userAccess("Kiosk PO", "order_menu");
    },
    checkPermissionAdd(){
      let tempPermission = false
      //console.log('currentDealer',this.currentDealer);
      if (this.currentDealer.status!=='Not Allowed' && this.permission.add){
        tempPermission = true
      }

      if(this.user.roleRef){
        if(this.user.roleRef.name==="Super Admin"||this.permission.add){
          tempPermission = true
        }
        
        
      }
      return tempPermission
    }
  },
  methods: {
    ...mapActions({
      getPurchase: 'purchase/getPurchase',
      editStatusPO: 'purchase/editStatusKioskPo'
    }),
    statusParser(item){
      var orderStatus = item.orderStatus;

      if(orderStatus === 'Draft'){
        return 'Draft'
      }else if(orderStatus === 'PO Fail'){
        return 'Pending'
      }

      var status = item.orderStatus;
      switch(status) {
        case '':
          return 'Created'
        default:
          return `${status}`
      }
    },
    doFiltering: lodash.debounce(function(value) {
      this.search = value;
      this.currentPage = 1;
      this.getPurchase({ 
        search: (this.search!="")?this.search:undefined,
        page: this.currentPage, 
        entry: this.perPage,
        orderStatus: this.sapStatus,
        kioskFlag : true
      }).then((data) => this.processMetadata(data.metadata));
    }, 500),
    statusFiltering: lodash.debounce(function(value) {
      this.sapStatus = value;
      this.currentPage = 1;
      
      let params = {
        search: (this.search!="")?this.search:undefined,
        page: this.currentPage,
        entry: this.perPage,
        allAccess: this.permission.all,
        kioskFlag : true
      };

      if (value === 'Created') {
        params = {
          ...params,
          orderStatus: 'Created',
        };
      } else {
        params = {
          ...params, 
          orderStatus: value,
        };
      }

      this.getPurchase(params).then((data) => this.processMetadata(data.metadata));
    }, 500),
    dates(date) {
      //console.info(date);
      return dateFormat(date);
    },
    onPageChange(page) {
      this.currentPage=page;

      this.getPurchase({ 
        search: (this.search!="")?this.search:undefined,
        page: this.currentPage, 
        entry: this.perPage
        ,orderStatus: this.sapStatus, allAccess: this.permission.all, kioskFlag : true
      }).then((data) => this.processMetadata(data.metadata));
    },
    processMetadata(metadata) {
      let { totalData } = metadata;
      this.totalRows = totalData;
      this.tableLoading = false;
    },
    deleteDraft(row){
      this.modalDelete = true;
      this.selectPO = row;
      // console.log(this.selectPO);
    },
    confirmDelete() {
      this.modalDelete = false
      this.$store
        .dispatch('purchase/deletePurchase', { id: this.selectPO._id })
        .then(res => {
          this.$bvToast.toast("Delete Kiosk Purchase Order Successfully", {
              title: "Success",
              variant: "success",
              solid: true,
            });
        })
        .catch(err => {
          console.error({ err })
          this.$bvToast.toast(err.response.data.error, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
          })
        })
    },
    detailPO(row) {
      let idOrder = row.item._id;
      this.$router.push({ name: 'order-detail', params: {  id: idOrder,from: 'kiosk' } });
    },
    editDraft(row) {
      this.$router.push(`/kiosk-po/edit/${row.item._id}`);
    },
    confirmEdit() {
      this.modalConfirmation = false
      let statusChange = ''
      if (this.messageModal == "Cancel") {
        statusChange = "Cancelled"
      }else if(this.messageModal == "Change status to need edit"){
        statusChange = "Need Edit"
      }else if(this.messageModal == "Change status to awaiting acknowledgement"){
        statusChange = "Editing"
      }
      let payloadData = { status : statusChange}
      this.editStatusPO({ id : this.selectPO._id, data : payloadData})
      .then(async (response) => {
        this.getPurchase({ 
          page:this.currentPage, 
          entry:this.perPage,
          orderStatus: this.sapStatus, 
          allAccess: this.permission.all, 
          kioskFlag: true})
        .then((data) => this.processMetadata(data.metadata));
        this.$bvToast.toast(`Edit Status Kiosk Purchase Order to ${statusChange}Successfully`, {
          title: "Success",
          variant: "success",
          solid: true,
        });
      })
      .catch(async (e) => {
        console.log(e);
        this.$bvToast.toast("Edit status Kiosk Purchase Order Failed", {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
      });
    },
    cancelOrder(row) {
      this.modalConfirmation = true
      this.modalTitle = "Cancel Kiosk PO"
      this.messageModal = "Cancel"
      this.selectPO = row.item
    },
  },
  created() {
    document.title = 'Kiosk PO | RSP';

    
    this.getPurchase({ page:this.currentPage, entry:this.perPage,orderStatus: this.sapStatus, allAccess: this.permission.all, kioskFlag : true })
    .then((data) => this.processMetadata(data.metadata));
  },
}
</script>
<style lang="scss">
  .custom-row-height {
    min-height: 120px; /* Adjust this value as needed */
  }
  .compact-header {
    th {
      padding: 0.4rem 0.3rem !important;
      font-size: 0.7rem !important; /* Added !important */
    }
  }
  
  /* Increase specificity by targeting the table element */
  .b-table.table thead.compact-header th {
    font-size: 0.7rem !important;
    padding: 0.4rem 0.3rem !important;
  }
  
  .compact-body {
    td {
      padding: 0.3rem !important;
      font-size: 0.9rem;
    }
  }

  .dropdown-show{
    overflow-y: auto;
    height: 80px;
  }
</style>
